import { Dict } from '../types';

export const EMPTY_ARRAY = Object.freeze([]) as Readonly<any[]>;
export const EMPTY_OBJECT = Object.freeze({}) as Readonly<Dict<any>>;
